<template>
  <i-input
    v-model="_value"
    :style="{ width: width ? `${width}px` : 100 + '%' }"
    :disabled="disabled"
    :placeholder="placeholder"
    @on-blur="onBlurInput"
  />
</template>

<script>
import Common from '@/mixins/common'
import { Input } from 'view-design'

export default {
  mixins: [Common],
  components: {
    'i-input': Input,
  },
  props: {
    value: {
      type: [String, Number],
      required: false,
    },
    placeholder: {
      type: String,
      default: '半角数字',
    },
    width: {
      type: Number,
      default: null,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    _value: {
      get() {
        // カンマ区切りへ変換
        return this.value === 0 || this.value ? this.value.toLocaleString() : ''
      },
      set(val) {
        this.$emit('update:value', val)
      },
    },
  },
  watch: {
    disabled(val) {
      if (val) this._value = null
    },
  },
  data() {
    return {}
  },
  methods: {
    // 入力値をフォーマットする
    formatValue(val) {
      let numValue = ''
      // カンマを取る
      if (val && val !== 0) numValue = String(val).replace(/,/g, '')
      // 全角数字を半角に変換
      numValue = this.toHalfWidthNumber(numValue)
      // 数字変換
      if (numValue && numValue !== 0 && numValue !== '') numValue = Number(numValue)
      // 無効な値（ひらがな・カタカナ・英字など）はnullへ変換
      numValue = numValue === '' || isNaN(numValue) ? null : numValue
      return numValue
    },
    // blur処理（フォーカスが外れたときにフォーマット適用）
    onBlurInput() {
      this._value = this.formatValue(this._value)
    },
  },
}
</script>

<style lang="scss" scoped></style>
